// FORCHETTA — Header dropdown background fix
function fixHeaderColors() {
  const headerComponent = document.querySelector('#header-component');
  if (headerComponent) {
    headerComponent.style.setProperty('--color-scheme-top-row', 'rgba(237, 236, 232, 1.0)', 'important');
    headerComponent.style.setProperty('--color-scheme-bottom-row', 'rgba(237, 236, 232, 1.0)', 'important');
  }
}

document.addEventListener('DOMContentLoaded', fixHeaderColors);
document.addEventListener('mouseover', function(e) {
  if (e.target.closest('.menu-list__link')) {
    fixHeaderColors();
  }
});